import { ConnectionRequest } from 'src/app/components/user-relation-requests/relation-request.interface';
import { UserTableConstructorInfo } from 'src/app/interfaces/tables.interfaces';
import { RelationRequestTables } from './table-creator.enum';

export abstract class RelationRequestTableFactory<T extends ConnectionRequest> {
  public abstract buildTableConstructorData(type: RelationRequestTables, data: T[]): UserTableConstructorInfo;
}
